<h1 mat-dialog-title>Contact Us </h1>
<div id="footer-cu-section-content" mat-dialog-content>
    Please contact the number on the correspondence you received or dial {{PhoneNumber}}.
    A representative will be available to assist you Monday to Friday between 8:00 AM and 5:00 PM EST.
</div>
<div id="footer-cu-section-action" mat-dialog-actions align="end" >
    <button id="footer-cu-button-close" mat-flat-button mat-dialog-close color="accent">Close</button>
</div>

